module.exports = __webpack_public_path__ + "static/policy_book1_7-4dde925b28d4564b88346b0da40e1351.png";